import ReportsAddDataElementTour from 'webapp/models-custom/tour/reports/add-data-element';
import ReportsAddDataStoryTour from 'webapp/models-custom/tour/reports/add-data-story';
import ReportsAddNoteTour from 'webapp/models-custom/tour/reports/add-note';
import ReportsChangeDataStorySettingsTour from 'webapp/models-custom/tour/reports/change-data-story-settings';
import ReportsCreateNewSlideTour from 'webapp/models-custom/tour/reports/create-new-slide';
import ReportsDownloadPdfTour from 'webapp/models-custom/tour/reports/download-pdf';
import ReportsFavoriteTour from 'webapp/models-custom/tour/reports/favorite';
import ReportsFirstPreviewTour from 'webapp/models-custom/tour/reports/first-preview';
import ReportsPlansGrowthTour from 'webapp/models-custom/tour/reports/plans-performer';
import ReportsPreviewPopupEditTour from 'webapp/models-custom/tour/reports/preview-popup-edit';
import ReportsPreviewPopupShareTour from 'webapp/models-custom/tour/reports/preview-popup-share';
import ReportsReorderSlidesTour from 'webapp/models-custom/tour/reports/reorder-slides';
import ReportsSelectDataElementTour from 'webapp/models-custom/tour/reports/select-data-element';
import ReportsSelectDataStoryTour from 'webapp/models-custom/tour/reports/select-data-story';

export {
	ReportsAddDataElementTour,
	ReportsAddDataStoryTour,
	ReportsAddNoteTour,
	ReportsChangeDataStorySettingsTour,
	ReportsCreateNewSlideTour,
	ReportsDownloadPdfTour,
	ReportsFavoriteTour,
	ReportsFirstPreviewTour,
	ReportsPlansGrowthTour,
	ReportsPreviewPopupEditTour,
	ReportsPreviewPopupShareTour,
	ReportsReorderSlidesTour,
	ReportsSelectDataElementTour,
	ReportsSelectDataStoryTour,
};
